import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static targets = ["preview"]
  static values = { url: String }

  connect() {
    // 初期状態を記憶
    this.isPreviewVisible = !this.previewTarget.classList.contains("hidden")

    // preview要素のclass変化を監視
    this.observer = new MutationObserver(mutations => {
      for (let mutation of mutations) {
        if (mutation.type === "attributes" && mutation.attributeName === "class") {
          const nowVisible = !this.previewTarget.classList.contains("hidden")

          // hidden => 表示 へ変わった瞬間だけ loadPreview() を呼ぶ
          if (nowVisible && !this.isPreviewVisible) {
            this.loadPreview()
          }
          // 現在状態を更新
          this.isPreviewVisible = nowVisible
        }
      }
    })

    this.observer.observe(this.previewTarget, {
      attributes: true,
      attributeFilter: ["class"]
    })
  }

  disconnect() {
    this.observer.disconnect()
  }

  loadPreview() {
    const form = this.element.querySelector("form")
    const formData = new FormData(form)

    if (formData.has('_method')) formData.delete('_method')

    // Extract ID from form action if editing existing content
    let previewUrl = this.urlValue
    const formAction = form.action
    
    // Try multiple patterns to extract ID
    let match = formAction.match(/public_contents\/([^\/]+)/)
    if (!match) {
      // Try alternative pattern
      match = formAction.match(/\/(\w+)$/)
    }
    
    if (match && match[1] && match[1] !== 'public_contents') {
      formData.append('id', match[1])
    }

    // CSRFトークンは @rails/request.js が自動的に付与してくれる
    post(previewUrl, {
      body: formData,
      responseKind: "text"
    })
      .then(response => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`)
        }
        return response.text
      })
      .then(html => {
        this.previewTarget.innerHTML = html
      })
      .catch(error => {
        console.error("Preview Error:", error)
      })
  }
}
